/**
 * HomepageLatestUpdate Block Template
 * By Prashant Bhatt <pbhatt@svb.com> (www.svb.com)
 * Summary
 * This component renders HomepageLatestUpdate Block
 */
import React, { useEffect, useState, useRef } from 'react';
import { SVBTypography } from '@svb/svb-react-components';
import Loading from '@svb/api-loading-component/dist/components/index';
// import { Utils } from '@svb/api-content-component';
import { browseAPIhandler } from '../../helpers/browseAPIhandler';
import { getFileContent } from '../../helpers/utilityFunctions';
import Carousel from 'react-bootstrap/Carousel';

/**
 * HomepageLatestUpdate
 * @param content: url of the HomepageIntegratedSolutions content
 * @returns HomepageLatestUpdate block
 */

const HomepageTestimonials = ({ datatestid, testMockContent, content, backgroundImg }) => {
  const [loading, setLoading] = useState(true);
  //   @todo: this is not been used anywhere even in carousel where it was has no effect, remove if no need for it
  //   const [selectedIndex, setSelectedIndex] = useState(0);
  //   const handleSelect = (selectedIndex) => {
  //     console.log(selectedIndex)
  //     setSelectedIndex(selectedIndex);
  //   };
  const ref = useRef(null);
  // const token = localStorage.getItem('token');
  const { regenTokenandBrowse } = browseAPIhandler();
  const HomepageTestimonialsSection = datatestid
    ? testMockContent
    : getFileContent(`${content}`, regenTokenandBrowse);
  useEffect(() => {
    if (HomepageTestimonialsSection.type === 'success') {
      setLoading(false);
    }
  }, [HomepageTestimonialsSection.response]);
  const onPrevClick = () => {
    ref.current.prev();
  };
  const onNextClick = () => {
    ref.current.next();
  };

  // const sectionTitle = Object.keys(HomepageTestimonialsSection.response);
  let backgroundImagePath;
  try {
    backgroundImagePath = backgroundImg && require('@svb/svbbranding/dist/assets/icons' + backgroundImg)
  } catch (error) {
    console.log(`Error: Cannot find icon ${backgroundImg}`)
    //fallback empty icon
    backgroundImagePath = "data:image/svg+xml;charset=utf8,%3Csvg%20xmlns='http://www.w3.org/2000/svg'%3E%3C/svg%3E";
  }
  // const backgroundImagePath = backgroundImg
  //   ? require('@svb/svbbranding/dist/assets/icons' + backgroundImg)
  //   : null;
  const bg_img = backgroundImagePath ? { backgroundImage: `url(${backgroundImagePath})` } : {};
  return (
    loading ? <Loading /> :
      <section
        data-testid={datatestid}
        id='homepage-testimonials'
        className='testimonials-section'
        style={bg_img}
      >
        <div className='container svb-container-fixed col-md-9 col-sm-12'>
          <div className='row'>
            <div className="d-flex">
              <div className='col-1 col-md-1 svb-control-container'>
                <div className='svb-carousel-control-prev-wrapper' data-testid="left-arrow">
                  <span onClick={onPrevClick} className='svb-carousel-control-prev'>
                    <i className='fa fa-chevron-left'></i>
                  </span>
                </div>
              </div>
              <div className='col-10 col-md-10 svb-testimonials-carousel'>
                <Carousel bsPrefix='carousel' ref={ref} controls={false} >
                  {HomepageTestimonialsSection.response.map((item, index) => {
                    let iconImagePath;
                    try {
                      iconImagePath = item.testimonialsIcon && require('@svb/svbbranding/dist/assets/icons/' + item.testimonialsIcon);
                    } catch (error) {
                      console.log(`Error: Cannot find icon ${item.testimonialsIcon}`)
                      //fallback empty icon
                      iconImagePath = "data:image/svg+xml;charset=utf8,%3Csvg%20xmlns='http://www.w3.org/2000/svg'%3E%3C/svg%3E";
                    }
                    // const iconImagePath = item.testimonialsIcon
                    //   ? require('@svb/svbbranding/dist/assets/icons/' + item.testimonialsIcon)
                    //   : '';
                    return (
                      // <React.Fragment key={index}>
                      <Carousel.Item key={index}>
                        <div className='d-flex align-items-center homepage_sd_cotainer flex-column flex-md-row'>
                          <div className='homepage_sd__image'>
                            <img src={iconImagePath} alt={item.iconlabel} width='76' height='36' loading='lazy' />
                          </div>
                          <div className='homepage_sd__content'>
                            <SVBTypography type='heading-medium' variant='homepage_sd_content'>
                              {`"${item.heading}"`}
                            </SVBTypography>
                            <SVBTypography type='sub-heading' variant='small homepage_sd__subcontent row'>
                              <div className='d-flex flex-column flex-md-column flex-lg-row'>
                                <span className='homepage__slider_scroll'>{item.clientName}</span>
                                <span className='homepage__slider_scroll'>{item.clientPosition}</span>
                                <span className='homepage__slider_scroll'>
                                  Client since {item.clientSince}
                                </span>
                              </div>
                            </SVBTypography>
                          </div>
                        </div>
                      </Carousel.Item>
                      //  </React.Fragment>
                    );
                  })}
                </Carousel>
              </div>
              <div className='col-1 col-md-1 svb-control-container'>
                <div className='svb-carousel-control-next-wrapper' data-testid="right-arrow">
                  <span onClick={onNextClick} className='svb-carousel-control-next'>
                    <i className='fa fa-chevron-right'></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
  );
};

export default HomepageTestimonials;
